module.exports = __webpack_public_path__ + "img/client-2.cebb2bf7.jpg";